import { Grid, Stack, Avatar } from '@mui/material';
// import { MouseEventHandler } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BottomActionBar, WsColors, WsTypography, WsTypoColors, WsButton } from 'wisestep-base';

import ErrorLogger from '../../../../providers/ErrorLogger';
import { failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

interface CandidateBulkSelectionBarProps {
  selectedCandidates: number;
  selectAllCandidates: () => void;
  unselectAllCandidates: () => void;
  openBulkSms?: () => void;
  openEmail?: () => void;
  onShareEmailClick?: () => void;
  amplitudeEventHandler?: (eventType: string) => void;
  showSendEmail?: boolean;
  onBulkSubmitClick?: () => void;
  onUpdateClick?: () => void | undefined;
}
export enum SourceType {
  JOBCRM = 'jobCrm',
  JOBCRM_SMART_SOURCE_AI_SUGGESTIONS = 'jobCrmSmartSourceAiSuggestions',
  JOBCRM_SMART_SOURCE_SIMILAR_JOBS = 'jobCrmSmartSourceSimilarJobs',
}
const CandidateBulkSelectionBar = ({
  selectedCandidates,
  selectAllCandidates,
  unselectAllCandidates,
  openBulkSms,
  openEmail,
  onShareEmailClick,
  amplitudeEventHandler,
  showSendEmail = true,
  onBulkSubmitClick,
  onUpdateClick,
}: CandidateBulkSelectionBarProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const onSendEmailClick = () =>
    selectedCandidates > 50
      ? setNotification(failed('Cannot send emails to more than 50 candidates in a campaign'))
      : openEmail && openEmail();

  const onSendSMSClick = () =>
    selectedCandidates > 50
      ? setNotification(
          failed('You cannot send SMS messages to more than 50 candidates in a campaign')
        )
      : openBulkSms && openBulkSms();

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
      <BottomActionBar>
        <Grid item xs={6}>
          <Stack direction="row">
            <Grid item pr={1}>
              <Stack direction="row">
                <Grid item pr={0.5}>
                  <Avatar
                    variant="square"
                    sx={{ bgcolor: WsColors.TheBlues400, width: 24, height: 24 }}
                  >
                    <WsTypography color={WsTypoColors.WHITE}>{selectedCandidates}</WsTypography>
                  </Avatar>
                </Grid>
                <Grid item>
                  <WsTypography color={WsTypoColors.PRIMARY}>Candidate(s) Selected</WsTypography>
                </Grid>
              </Stack>
            </Grid>
            <Grid item pr={1}>
              <WsButton
                onClick={() => {
                  selectAllCandidates();
                  if (amplitudeEventHandler) {
                    amplitudeEventHandler('Select candidate');
                  }
                }}
              >
                Select All
              </WsButton>
            </Grid>
            <Grid item>
              <WsButton
                onClick={() => {
                  unselectAllCandidates();
                  if (amplitudeEventHandler) amplitudeEventHandler('UnSelect candidate');
                }}
              >
                UnSelect All
              </WsButton>
            </Grid>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack direction="row" justifyContent="flex-end">
            {onUpdateClick && (
              <Grid item pr={1}>
                <WsButton id="update_status" onClick={onUpdateClick}>
                  Update Status
                </WsButton>
              </Grid>
            )}
            {onShareEmailClick && (
              <Grid item pr={1}>
                <WsButton onClick={onShareEmailClick}>Email Profile</WsButton>
              </Grid>
            )}
            {showSendEmail && (
              <Grid item pr={1}>
                <WsButton onClick={onSendEmailClick}>Send Email</WsButton>
              </Grid>
            )}
            <Grid item>
              <WsButton onClick={onSendSMSClick}>Send SMS</WsButton>
            </Grid>
            {onBulkSubmitClick && (
              <Grid item pl={1} pr={1}>
                <WsButton onClick={onBulkSubmitClick} disabled={false}>
                  Submit
                </WsButton>
              </Grid>
            )}
          </Stack>
        </Grid>
      </BottomActionBar>
    </ErrorBoundary>
  );
};
export default CandidateBulkSelectionBar;
